<div class="box-content rd-widget widget-{{widgetConfig.widgetId}} widgetSiteInformation widgetNoTopBorder rd-widget-no-height-restriction" *ngIf="widgetData">
  <div class="table-part">
    <table class="widget-flex" style="height: 100%; table-layout: auto;" aria-hidden="true" *ngIf="currentLayout === 'Large'">
      <thead>
        <tr class="widget-ruller-flex alignCenter gray-thead">
          <th scope="col" class="widget-grid-column autoWith">&nbsp;</th>
          <th scope="col" class="widget-grid-column autoWith">{{'dcfGrowthRateInflationIndex.labelYearCAGR'| rdTranslate}}</th>
          <th scope="col" class="widget-grid-column">{{'dcfGrowthRateInflationIndex.labelYear1'| rdTranslate }}</th>
          <th scope="col" class="widget-grid-column">{{'dcfGrowthRateInflationIndex.labelYear2'| rdTranslate }}</th>
          <th scope="col" class="widget-grid-column">{{'dcfGrowthRateInflationIndex.labelYear3To5'| rdTranslate }}</th>
          <th scope="col" class="widget-grid-column">{{'dcfGrowthRateInflationIndex.labelYear6To10'| rdTranslate }}</th>
        </tr>
        <tr class="widget-ruller-flex alignCenter gray-thead">
          <th scope="col" class="widget-grid-column autoWith alignLeft padding-left">{{'dcfGrowthRateInflationIndex.labelStart'| rdTranslate}}</th>
          <th scope="col" class="widget-grid-column top-border-white">{{getStartDate(widgetData.dcfStartDate, 1) | rdLocalizedDate}}</th>
          <th scope="col" class="widget-grid-column top-border-white">{{getStartDate(widgetData.dcfStartDate, 1) | rdLocalizedDate}}</th>
          <th scope="col" class="widget-grid-column top-border-white">{{getStartDate(widgetData.dcfStartDate, 2) | rdLocalizedDate}}</th>
          <th scope="col" class="widget-grid-column top-border-white">{{getStartDate(widgetData.dcfStartDate, 3) | rdLocalizedDate}}</th>
          <th scope="col" class="widget-grid-column top-border-white">{{getStartDate(widgetData.dcfStartDate, 6) | rdLocalizedDate}}</th>
        </tr>
        <tr class="widget-ruller-flex alignCenter gray-thead ">
          <th scope="col" class="widget-grid-column autoWith alignLeft padding-left">{{'dcfGrowthRateInflationIndex.labelEnd'| rdTranslate}}</th>
          <th scope="col" class="widget-grid-column top-border-white">{{getEndDate(widgetData.dcfStartDate, 10 ) | rdLocalizedDate }}</th>
          <th scope="col" class="widget-grid-column top-border-white">{{getEndDate(widgetData.dcfStartDate, 1 ) | rdLocalizedDate }}</th>
          <th scope="col" class="widget-grid-column top-border-white">{{getEndDate(widgetData.dcfStartDate, 2 ) | rdLocalizedDate }}</th>
          <th scope="col" class="widget-grid-column top-border-white">{{getEndDate(widgetData.dcfStartDate, 5 ) | rdLocalizedDate }}</th>
          <th scope="col" class="widget-grid-column top-border-white">{{getEndDate(widgetData.dcfStartDate, 10 ) | rdLocalizedDate }}</th>
        </tr>
      </thead>
      <tbody class="alternate-row-colors">
        <ng-container *ngFor="let row of widgetData.rows">
          <tr class="widget-ruller-flex" *ngIf="row.label && row.label !== '' && row.label != null">
            <td class="widget-grid-column autoWith">
              <widget-value [align]="'left'">{{row.label}}</widget-value>
            </td>
            <td class="widget-grid-column">
              <widget-value [align]="'center'">{{( (row.total * 100 || 0) | rdLocalizedNumber:2)}}%</widget-value>
            </td>
            <td class="widget-grid-column">
              <widget-value [align]="'center'">{{( (row.year1 * 100 || 0) | rdLocalizedNumber:2)}}%</widget-value>
            </td>
            <td class="widget-grid-column">
              <widget-value [align]="'center'">{{( (row.year2 * 100 || 0) | rdLocalizedNumber:2)}}%</widget-value>
            </td>
            <td class="widget-grid-column">
              <widget-value [align]="'center'">{{( (row.year3To5 * 100 || 0) | rdLocalizedNumber:2)}}%</widget-value>
            </td>
            <td class="widget-grid-column">
              <widget-value [align]="'center'">{{( (row.year6To10 * 100 || 0) | rdLocalizedNumber:2)}}%</widget-value>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

    <table class="widget-flex" aria-hidden="true">
      <thead>
        <tr class="hidden">
          <th scope="col" colspan="20">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="20">
            <div class="k-donut-chart-container-print-fix" style="height: 380px;">
              <kendo-chart class="k-donut-chart-area" *ngIf="chartsReady" [transitions]="chartTransitionsEnabled">
                <kendo-chart-title text="{{'dcfGrowthRateInflationIndex.labelFactors' | rdTranslate}}" font="16px Arial"></kendo-chart-title>
                <kendo-chart-area background="white" height="330"></kendo-chart-area>

                <kendo-chart-value-axis>
                  <kendo-chart-value-axis-item [visible]="false">
                  </kendo-chart-value-axis-item>
                </kendo-chart-value-axis>

                <kendo-chart-category-axis>
                  <kendo-chart-category-axis-item [categories]="categories" [axisCrossingValue]="[0, categories.length]" [justified]="true">
                    <kendo-chart-category-axis-item-labels font="12px Arial" rotation="auto"></kendo-chart-category-axis-item-labels>
                  </kendo-chart-category-axis-item>
                </kendo-chart-category-axis>

                <kendo-chart-series>
                  <kendo-chart-series-item *ngFor="let item of widgetData.chartData; let i = index;" type="line" [name]="item.name" [color]="item.color"
                                           [data]="item.data">
                    <kendo-chart-series-item-labels background="none" [content]="labelContent" [margin]="-8" font="12px Arial">
                    </kendo-chart-series-item-labels>
                  </kendo-chart-series-item>
                </kendo-chart-series>

                <kendo-chart-legend [visible]="true" [labels]="{color: '#000000', font: '12px Arial'}" position="bottom" orientation="horizontal"></kendo-chart-legend>
              </kendo-chart>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
